import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

// API endpoints
const API_LIST = '/p-frequency-type';
const API_DETAIL = (id: number) => `/p-frequency-type/${id}`;

export interface FrequencyType {
  id: number;
  name?: string;
}

export const useFrequencyTypes = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<FrequencyType[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    frequencyTypes: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const useFrequencyType = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<FrequencyType>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    frequencyType: data,
    isLoading,
    isError: error,
    mutate,
  };
};
